import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BeyondCreateComponent } from './beyond-create/beyond-create.component';
import { BeyondListComponent } from './beyond-list/beyond-list.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: BeyondListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: BeyondCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'beyond-create/:id',
        component: BeyondCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BeyondRoutingModule { }
